import { Cashback } from "./components/cashback/cashback";
import { Discount } from "./components/discount/discount";
import { EveryDayLowPrice } from "./components/everyDayLowPrice/everyDayLowPrice";
import { Recupel } from "./components/recupel/recupel.component";
import { WebOnly } from "./components/webOnly/webOnly.component";
import { PricingBase } from "./pricing.base";

export const Pricing = Object.assign(PricingBase, {
    WebOnly: WebOnly,
    Discount: Discount,
    Cashback: Cashback,
    EveryDayLowPrice: EveryDayLowPrice,
    Recupel: Recupel
});
